import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeCartItem } from "../../redux/features/cartSlice";
import { Link } from "react-router-dom";

const SelectAll = () => {
  const dispatch = useDispatch();
  //get cart from redux
  const cartItems = useSelector((state) => state.cart.cartItems);


  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState(new Set());

  useEffect(() => {
    if (selectAll) {
      const allItemIds = new Set(cartItems.map((item) => item?.product));
      setSelectedItems(allItemIds);
    } else {
      setSelectedItems(new Set());
    }
  }, [selectAll, cartItems]);

  const removeFromCartHandler = () => {
    selectedItems.forEach((itemId) => {
      dispatch(removeCartItem(itemId));
    });

    // Optionally, clear selection after removal
    setSelectedItems(new Set());
    setSelectAll(false);
  };

  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
          checked={selectedItems.size === cartItems.length}
          onChange={(e) => {
            // If checkbox is checked, select all items. Otherwise, clear selection.
            if (e.target.checked) {
              const allItemIds = new Set(cartItems.map((item) => item?.product)); // Assuming each item has a unique `_id`.
              setSelectedItems(allItemIds);
            } else {
              setSelectedItems(new Set());
            }
          }}
        />
        <label htmlFor="select_all" className="text-sm text-gray-700">
          Select/Deselect all
        </label>
      </div>
      <div className="flex-grow text-right">
        <Link
          onClick={removeFromCartHandler}
          className="text-red-500 hover:text-red-700"
        >
          <i className="fas fa-trash mr-1"></i>
          Remove All Items
        </Link>
      </div>
    </div>
  );
};

export default SelectAll;
